// The death-moment revive offer. Two flavours, one overlay (the rule for which
// one appears lives in game/revive.ts):
//   'newbie' — free, device's first run only (design §2.6). No ad.
//   'ad'     — 看个广告，原地复活, once per run (design §8.1), only ever shown
//              when a rewarded ad is already loaded (§4.6).

import { t } from '../i18n';
import type { ReviveKind } from '../game/revive';
import { el, enter } from './dom';

export interface ReviveOptions {
  seconds?: number;
  /** Defaults to the free newbie revive. */
  kind?: ReviveKind;
  onTick?: (secondsLeft: number) => void;
}

/** Resolves true if the player takes the revive, false on decline/timeout. */
export function showReviveOffer(root: HTMLElement, opts: ReviveOptions = {}): Promise<boolean> {
  const total = opts.seconds ?? 3;
  const kind: ReviveKind = opts.kind ?? 'newbie';
  const acceptKey = kind === 'ad' ? 'revive.ad.accept' : 'revive.accept';
  return new Promise((resolve) => {
    let left = total;
    let timer: ReturnType<typeof setInterval> | null = null;

    const accept = el('button', {
      class: 'btn btn--primary',
      text: t(acceptKey, { s: left }),
      attrs: { type: 'button' },
    });
    const decline = el('button', {
      class: 'btn btn--ghost',
      text: t('revive.decline'),
      attrs: { type: 'button' },
    });

    // The ad title already says both what happens and what it costs, so it
    // carries no second line — a body under it would just repeat itself.
    const body =
      kind === 'ad' ? [] : [el('div', { class: 'revive-body', text: t('revive.body') })];

    const screen = el('div', { class: 'screen screen--revive' }, [
      el('div', {
        class: 'revive-title',
        text: t(kind === 'ad' ? 'revive.ad.title' : 'revive.title'),
      }),
      ...body,
      accept,
      decline,
    ]);

    const finish = (taken: boolean): void => {
      if (timer !== null) clearInterval(timer);
      screen.remove();
      resolve(taken);
    };

    accept.addEventListener('click', () => finish(true));
    decline.addEventListener('click', () => finish(false));

    timer = setInterval(() => {
      left -= 1;
      opts.onTick?.(left);
      if (left <= 0) {
        finish(false);
        return;
      }
      accept.textContent = t(acceptKey, { s: left });
    }, 1000);

    root.append(screen);
    enter(screen);
  });
}
